import { MonthlyDownloadDate } from './MonthlyDownloadDate';

export class ListMonthlyDownloadDateResult {
  success: boolean;
  error: string;
  monthlyDownloadDates: MonthlyDownloadDate[] = [];
}
